export default {
  data() {
    return {
      isOpenPopup: false,
      nameSelectedTab: 'Коммуникации',
      sectionsList: [
        {
          name: 'Коммуникации',
          isActive: false,
          form: {
            id: 'main-products-application-communication',
            idValue: '1e62a764-6a31-4f2d-9858-6676ca5a57df',
          },
          productsList: [
            {
              id: 1,
              isExpand: false,
              title: 'Чаты',
              link: '/products/messenger/',
              content:
                'Корпоративный мессенджер для\u00A0всей компании. Общайтесь в\u00A0диалогах и\u00A0каналах, объединяйтесь в\u00A0команды, созванивайтесь с\u00A0видео и\u00A0без',
              video: 'mts-main-products-chats',
            },
            {
              id: 2,
              isExpand: false,
              title: 'Задачи',
              link: '/products/task-management/',
              content:
                'Сервис для управления рабочими задачами. Ставьте\u00A0задачи из\u00A0сообщений в\u00A0мессенджере, отмечайте прогресс, быстро находите нужное',
              image: 'main/main--products/task-management'
            },
            {
              id: 3,
              isExpand: false,
              title: 'Встречи',
              link: '/products/meetings/',
              content:
                'Самый стабильный сервис для\u00A0встреч и\u00A0совещаний со\u00A0встроенными возможностями искусственного интеллекта',
              video: 'mts-main-products-meetings',
            },
            {
              id: 4,
              isExpand: false,
              title: 'Доски',
              link: '/products/boards/',
              content:
                'Онлайн-доска для\u00A0совместной работы. Визуализируйте проекты и\u00A0процессы, фиксируйте договорённости, используйте во\u00A0время встреч',
              video: 'mts-main-products-boards',
            },
            {
              id: 5,
              isExpand: false,
              title: 'Оборудование',
              link: '/products/software-and-equipment/',
              content:
                'Оборудуем с\u00A0нуля или\u00A0переустановим ПО в\u00A0переговорных комнатах, аудиториях и\u00A0конференц-залах любой площади',
              video: 'mts-main-products-equipment',
            },
          ],
        },
        {
          name: 'Обучение',
          isActive: false,
          form: {
            id: 'main-products-application-education',
            idValue: 'f8873ac7-5f46-4f28-bc48-3a63a17fc07a',
          },
          productsList: [
            {
              id: 1,
              isExpand: false,
              title: 'Вебинары',
              link: '/products/webinar/',
              content:
                'Платформа для\u00A0онлайн-обучения клиентов, партнеров и\u00A0сотрудников. Инструменты вовлечения, ИИ, статистика',
              video: 'mts-main-products-webinars',
            },
            {
              id: 2,
              isExpand: false,
              title: 'Курсы',
              link: '/products/westudy/',
              content:
                'Платформа для\u00A0создания онлайн-курсов и\u00A0организации обучения. Простой редактор, журнал со\u00A0статистикой, прием платежей и\u00A0выдача сертификатов',
              video: 'mts-main-products-courses',
            },
            {
              id: 3,
              isExpand: false,
              title: 'Формы',
              link: '/products/forms/',
              content:
                'Универсальный конструктор тестов и\u00A0опросов с\u00A0автопроверкой ответов. Для\u00A0оценки знаний, сбора обратной связи и\u00A0проведения интерактивов',
              video: 'mts-main-products-forms',
            },
            {
              id: 4,
              isExpand: false,
              title: 'COMDI',
              link: '/products/comdi/',
              content:
                'Сервисы для\u00A0гибридных и\u00A0онлайн-мероприятий с\u00A0видеосъемкой и\u00A0цифровой платформой. Организация корпоративных, маркетинговых, деловых событий',
              video: 'mts-main-products-comdi',
            },
          ],
        },
      ],
    }
  },
  computed: {
    idxSelectedSection() {
      const idx = this.sectionsList.findIndex((section) => {
        return section.name.toLowerCase() === this.nameSelectedTab.toLowerCase()
      })
      return idx || 0
    },
  },
  methods: {
    openPopup() {
      this.isOpenPopup = true
    },
    closePopup() {
      this.isOpenPopup = false
    },
  },
}
